import Drawer from '@material-ui/core/Drawer';
import styled from 'styled-components';
import { COLORS } from 'constants/design';

export const AppBarDiv = styled.div`
  &&.root {
    flex-grow: 1;
  }
  header {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  }
  .title {
    flex-grow: 1;
  }
  .appbarstyle {
    top: 0px;
    left: 0px;
    width: 1440px;
    height: 64px;
    background: ${COLORS.WHITE} 0% 0 % no-repeat padding-box;
    opacity: 1;
  }
  .profil {
    top: 18px;
    left: 1329px;
    height: 15px;
    textalign: left;
    letterspacing: 0;
    color: ${COLORS.TEXT_BLACK};
    opacity: 1;
    margin: 0;
    font-size: 15px;
    font-weight: 600;
  }
  .logOutBtn {
    top: 34px;
    left: 1329px;
    width: 70px;
    height: 14px;
    textalign: left;
    letterspacing: 0;
    color: ${COLORS.LIGHT_GREY};
    opacity: 1;
    font-size: 15px;
    cursor: pointer;
  }
  .profilcontainer {
    width: 87px;
    marginleft: 10px;
  }
  .MuiIconButton-root {
    padding: 0px 6px 6px 6px;
  }
  .divider {
    width: 2px;
    background: ${COLORS.DEVIDER_GREY};
    height: 36px;
    margin: 0 10px;
  }
`;
export const BinDiv = styled.div`
  margin-top: -4px;
  height: 100%;
  width: 92%;
  display: flex;
  flex-direction: column;
`;

export const DrawerContainer = styled(Drawer)`
  .MuiDrawer-paper {
    overflow-y: visible;
    z-index: 230;
  }
`;

export const DrawerDiv = styled.div`
  width: 520px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .divider {
    width: 520px;
    background: ${COLORS.DEVIDER_GREY};
    height: 2px;
    margin-bottom: 10px;
  }
  .titleConatainer {
    height: 64px;
    padding-left: 24px;
    padding-top: 23px;
    padding-right: 10px;
    display: flex;
    justify-content: space-between;
  }
  .title {
    color: ${COLORS.BLUE};
    text-align: left;
    font-size: 15px;
    font-family: Roboto;
    font-weight: bold;
    letter-spacing: 0px;
    color: #0075c9;
    text-transform: uppercase;
    opacity: 1;
  }
  .actions {
    padding: 10px;
  }

  .action-buttons-container {
    padding: 0 10px;
  }

  .saveButton,
  .cancelButton {
    width: 126px;
    height: 36px;
  }

  .disabledSaveButton {
    width: 126px;
    height: 36px;
    background: #dddddd 0% 0% no-repeat padding-box;
    border: 1px solid #dddddd;
    color: #333e48;
    text-transform: none;
    cursor: not-allowed;
  }
  .rejectButton {
    width: 126px;
    height: 36px;
    margin-top: 5px;
  }
  .disabledRejectButton {
    width: 126px;
    height: 36px;
    background: #dddddd 0% 0% no-repeat padding-box;
    border: 1px solid #dddddd;
    color: #333e48;
    text-transform: none;
    cursor: not-allowed;
  }
  .content {
    overflow-y: scroll;
    height: 90%;
  }
`;
